import { api } from '../api'

export const createDrillRoom = async (roomId: string | number): Promise<{ id: string }> =>
  await api().url(`/api/drill/${roomId}/room`).post().json()
